import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Typography } from '@chilecompra/react-kit/components'
import { formatAmount, formatPercentage } from '../../modules/utils/formatters'
import { GridWrapper, Info, DetailWrap, PercentageDetail, TypeIcon } from './ProvidersType.styles'

/**
 * The ProvidersSeparators' container.
 */
const ProvidersSeparators = ({ data }) => {
  return (
    <GridWrapper container justifyContent="center" borderTop margin="24px 0 0 0">
      {data.map((item, index) => (
        <GridWrapper key={index} item xs={12} md align="center" className="icon-container">
          <TypeIcon
            src={`/assets/images/ico_providersType_${
              item.ProvidersCat === 'Pequeña' ? 'Pequena' : item.ProvidersCat
            }.svg`}
            alt="Micro"
          />
          <DetailWrap>
            <Typography variant="body2" fontSize="12px" align="left">
              {item.ProvidersCat === 'NoClasificado' ? (
                <>
                  <Tooltip
                    content={
                      <Typography color="white" fontSize="12px" lineHeight="16px">
                        Proveedores que no disponen de su clasificación por tamaño de empresa.
                      </Typography>
                    }
                    placement="top"
                  >
                    <Info>Sin clasificación</Info>
                  </Tooltip>
                </>
              ) : (
                item.ProvidersCat
              )}
              <PercentageDetail>({formatPercentage(item.percentage)})</PercentageDetail>
            </Typography>
            <Typography variant="body2" fontSize="16px" fontWeight="bold" align="left">
              ${formatAmount(item.totalAmount)}
            </Typography>
            <Typography variant="body2" fontSize="12px" fontWeight="bold" margin="0" color="black2" align="left">
              {item.totalOC} órdenes de compra
            </Typography>
          </DetailWrap>
        </GridWrapper>
      ))}
    </GridWrapper>
  )
}

ProvidersSeparators.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      ProvidersCat: PropTypes.string,
      totalAmount: PropTypes.number,
      totalOC: PropTypes.number,
      percentageAmount: PropTypes.number,
      percentageOC: PropTypes.number,
      color: PropTypes.string
    })
  )
}

export default ProvidersSeparators
